import { render, staticRenderFns } from "./ServerDetailLeft.vue?vue&type=template&id=c5f90542&"
import script from "./ServerDetailLeft.vue?vue&type=script&lang=js&"
export * from "./ServerDetailLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports